import Vue from "vue";
import Vuex from "vuex";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import requestCache from "./modules/requestCache";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    requestCache,
  },
  state: {
    pageLeftImg: localStorage.getItem("pageLeftImg"),
    navList: [],
    isLogin: utils.isLogin(),
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || {},
    mobAccountList: [
      {
        label: '尊敬的顾客',
        pathName: 'Account',
        key: ''
      },
      {
        label: '购物车',
        pathName: 'Cart',
        key: ''
      },
      {
        label: '我的订单',
        pathName: 'Orders',
        key: ''
      },
      {
        label: '客服中心',
        pathName: 'udesk-go-service',
        key: 'help'
      },
      {
        label: '店铺导航',
        pathName: 'Store-finder',
        key: ''
      },
    ],
    cartInfo: { list: [], },
    //OWHS-9910 - 【OT】网站和小程序前端请求header传上级页面URL
    historyListMax: 10,
    //从前往后插入元素
    historyList: [],
    //OWHS-10117 - 【OT】管小下单时最高抵扣积分由20% 改为30%
    //获取oss json全局配置
    commonConfig: {},
    tagsConfig: {}, // 标签管理
    isShowCustomerTag: false, // 是否展示标签
    cookieAccept: null,
    privacyAccept: null,
    showCookieDialog: false // 添加控制弹框显示的状态
  },
  mutations: {
    saveNavList(state, payload) {
      state.navList = payload.list;
      state.pageLeftImg = payload.register_left_pic;
      localStorage.setItem("pageLeftImg", state.pageLeftImg);
    },
    SET_IS_SHOW_CUSTOMER_TAG(state, value) {
      state.isShowCustomerTag = value;
      Vue.cookie.set("newCustomerState", value);
    },
    [types.LOGIN](state, payload) {
      utils.setToken(payload);
      state.isLogin = true;
    },
    [types.LOGOUT](state, payload) {
      utils.removeToken();
      localStorage.removeItem("userInfo");
      Vue.cookie.delete("userInfo");
      state.isLogin = false;
      state.userInfo = null;
      typeof payload == "function" && payload();
    },
    [types.GET_PROFILE](state, payload) {
      localStorage.setItem("userInfo", JSON.stringify(payload));
      state.userInfo = payload;
      if (payload.username) {
        state.mobAccountList[0].label = payload.username;
      }
      //nuxt不能用local存储 用cookie再存一遍
      // eslint-disable-next-line no-unused-vars
      const { crm, ...restPayload } = payload || {};
      Vue.cookie.set("userInfo", JSON.stringify(restPayload));
    },
    [types.GET_CART_INFO](state, payload) {
      state.cartInfo = payload;
    },
    [types.PUSH_HISTORY](state, payload) {
      // 如果队列已满，先移除最后一个元素
      if (state.historyList.length >= state.historyListMax) {
        state.historyList.pop();
      }
      // 然后在队列的最前面添加新元素
      state.historyList.unshift(payload);
    },
    [types.SET_COOKIE_ACCEPT](state, cookieAccept) {
      state.cookieAccept = cookieAccept;
    },
    [types.SET_PRIVACY_ACCEPT](state, privacyAccept) {
      state.privacyAccept = privacyAccept;
    },
    [types.SHOW_COOKIE_DIALOG](state, payload) {
      state.showCookieDialog = payload;
    }
  },
  actions: {
    setIsShowCustomerTag({ commit }, value) {
      commit('SET_IS_SHOW_CUSTOMER_TAG', value);
    },
    [types.LOGOUT]({ commit }, payload) {
      api[types.LOGOUT]()
        .then(() => {
          commit(types.LOGOUT, payload);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [types.GET_PROFILE]({ commit }) {
      api[types.GET_PROFILE]()
        .then((res) => {
          commit(types.GET_PROFILE, res.data);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [types.GET_CART_INFO]({ state, commit }, payload) {
      let newArgs = {};
      let localCart = utils.getCartInfo();
      // 将本地购物车数据合并查询
      if (localCart?.list?.length) {
        let ret = localCart.list.map((item) => `${item.id},${item.quantity}`);
        newArgs.ids = ret.join("|");
        // 登录状态则清空本地购物车信息
        state.isLogin && utils.clearCart();
      }
      api[types.GET_CART_INFO](newArgs)
        .then((res) => {
          if (res?.code == 1) {
            let _cart = res?.data?.list
              ? res.data
              : {
                list: [],
                shipping: "0.00",
                subTotal: "0.01",
                amount: "0.01",
              };
            commit(types.GET_CART_INFO, _cart);
            if (!state.isLogin) {
              //未登录 覆盖掉本地的cartInfo 清除无库存和库存不足
              localStorage.setItem("cart", JSON.stringify(_cart));
            }
            typeof payload == "function" && payload();
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // eslint-disable-next-line no-unused-vars
    [types.GET_OSS_COMMON_CONFIG]({ state }) {
      api[types.GET_OSS_COMMON_CONFIG]()
        .then((res) => {
          console.log("commonConfig", res.data);
          state.commonConfig = res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    [types.GET_OSS_TAGS]({ state }) {
      api[types.GET_OSS_TAGS]()
        .then((res) => {
          const allTagsPage =
            ["Category", "Detail", "Search", "Cart", "Checkout", "Orderdetail", "history", "recommend", "home"]
          const showPage = res.data?.web?.show_page;
          const showPageArr = showPage === 'allPage'
            ? allTagsPage
            : (showPage || []);
          state.tagsConfig = { ...res.data?.web, show_page: showPageArr } || {};
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    changeCrmPoint({ state, commit }, payload) {
      if (state.userInfo) {
        let _userInfo = state.userInfo;
        _userInfo.crm = { ..._userInfo.crm, points: payload };
        commit(types.GET_PROFILE, _userInfo);
      }
    },
  },
});
